import { createStandardAction } from 'typesafe-actions';
import * as Types from './types';


export const getMatchedListingsCount = createStandardAction(Types.GET_MATCHED_LISTINGS_COUNT)();
export const loadInvestorLastSearchListings = createStandardAction(Types.LOAD_INVESTOR_LAST_SEARCH_LISTINGS)();
